module.exports = __webpack_public_path__ + "static/vws-9ba775bd061a19b04cdba9b71b8113b6.jpg";